import { render, staticRenderFns } from "./bank-accounts.vue?vue&type=template&id=0f8da5a6&scoped=true&"
import script from "./bank-accounts.vue?vue&type=script&lang=js&"
export * from "./bank-accounts.vue?vue&type=script&lang=js&"
import style0 from "./bank-accounts.vue?vue&type=style&index=0&id=0f8da5a6&prod&lang=css&"
import style1 from "./bank-accounts.vue?vue&type=style&index=1&id=0f8da5a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f8da5a6",
  null
  
)

export default component.exports